import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
interface Response {
  error_code: number;
  error_msg: string;
  data: any;
}
const ADD_INVOICE_API = '/api/transaction/add_invoice';

@Injectable({
  providedIn: 'root'
})
export class UploadVoucherService {

  constructor(private http: HttpClient) { }

  createInvoice(params) {
    return this.http.post(ADD_INVOICE_API, params) as Observable<Response>;
  }

}
